import { Logger } from "../logger/Logger";

export function getLocalStorage<T>(key: string, defaultValue: T): T {
	try {
		const item = localStorage.getItem(key);
		return item ? JSON.parse(item) : defaultValue;
	} catch {
		Logger.log("Failed to get localStorage item: " + key + " with value: " + defaultValue);
		return defaultValue;
	}
}

export function setLocalStorage<T>(key: string, value: T): void {
	try {
		localStorage.setItem(key, JSON.stringify(value));
	} catch {
		Logger.error("Failed to set localStorage item: " + key + " with value: " + value);
	}
}
